__turbopack_context__.v({
  "className": "dancing_script_7b4b076f-module__3k5-ia__className",
  "variable": "dancing_script_7b4b076f-module__3k5-ia__variable",
});
